module.exports = __webpack_public_path__ + "assets/images/3bdf7c454a1afa0c1606260ccddfbc84.png";